module.exports = __webpack_public_path__ + "static/img/5.a312b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/5.png
// module id = zgdN
// module chunks = 0